/* global Cookies */

export default {

  init() {

    this.checkout_payments = $('.woocommerce-checkout-payment')
    this.checkout_delivery_options = $('.checkout-delivery-options')

    if (this.checkout_payments.length) {
      this.activePaymentMethod()
    }

    if (this.checkout_delivery_options.length) {
      this.deliveryOptions()
    }

    // The consent prompt may not be loaded straight away as it's added by Jilt. Inside this function is an interval check which keeps looping until it finds the relevant dom element and stops.
    this.checkoutConsentPrompt()

  },
  activePaymentMethod() {

    $( 'body' ).on( 'click', '.wc_payment_method', function() {

      // remove classes from all
      $('li').removeClass('active');
      
      // add class to the one we clicked
      $(this).addClass('active');

      // Klarna actively looks for a "change" of radio button then checks if the one selected is a Klarna method. So, trigger "change" if you click anywhere on or around one of the payment methods.
      $(this).find('.input-radio').prop('checked', true).trigger('change');
		});

    // Detect if the radio button with name of payment_method, is clicked specifically, and therefore changed.
    $( 'form.checkout' ).on( 'change', 'input[name^="payment_method"]', function() {

      // remove classes from all LI's with payment_method class.
      $('li.wc_payment_method').removeClass('active');
      
      // add class to the parent li of the element we clicked.
      $(this).parent('li').addClass('active');

    });

  },
  checkoutConsentPrompt() {

    // If cookie is found, user has already opted in to marketing when filling one of the OptinMonster pop-ups. So, don't ask them again during checkout. Else, if they don't select yes again, it marks them in Jilt as "does not accept marketing".
    if( Cookies.get('wp_optinmonster-optin') ) {

      // Create an interval which continues to look for the ID defined. When found, clear/end the interval to prevent looping.
      var timesRun = 0;
      var checkExist = setInterval(function() {

        timesRun += 1;

        if ($('#wc-jilt-checkout-consent').length) {
           
          // The checkout consent element is added via Jilt plugin, so may not be available immediately. Create a delay before looking for the element(s).
          // @TODO - When we move away from Jilt, remove this functionality and instead, do an API lookup of the user and if not already in the contact list, show the relevant optin box if needed.
          setTimeout(function() {
            $('#wc-jilt-checkout-consent').prop('checked', true);
            $('.wc-jilt-checkout-consent-prompt').hide();
          }, 100);
      
          clearInterval(checkExist);
        }

        // Allow to run X times, then clear interval to prevent an endless loop.
        if(timesRun === 10) {
          clearInterval(checkExist);
        }

      }, 500); // check every 500ms

    }

  },
  deliveryOptions() {

    // We've hidden two fields from the Billing fields list, but they still exist and will need values. We've added those fields seperately above all other fields, and when populated with data, will copy the value to the hidden fields.
    const checkoutPhoneInput = document.getElementById('checkout_phone');
    const billingPhoneInput = document.getElementById('billing_phone');
    
    // When input with #id of "checkout_phone" is changed, copy the value to #billing_phone.
    checkoutPhoneInput.addEventListener('input', function() {
      // Update the hidden input with the same value as the visible input
      billingPhoneInput.value = this.value;
    });
    
    // Get references to the visible and hidden input elements
    const checkoutEmailInput = document.getElementById('checkout_email');
    const billingEmailInput = document.getElementById('billing_email');

    // Add an event listener to the visible input element
    checkoutEmailInput.addEventListener('input', function() {
      // Update the hidden input with the same value as the visible input
      billingEmailInput.value = this.value;
    });
    
    // Toggle #ship-to-different-address-checkbox checkbox, check if already checked, if so add value="1" to checkbox, if not, remove value="1" from checkbox.
    // Check if "Ship to a different address" checkbox is checked, if so, show the "checkout__shipping-address-accordion-wrapper #accordion" div.
    $( 'body' ).on( 'click', '#ship-to-different-address-checkbox', function() {
      if ( $(this).is(':checked') ) {
        $(this).val('1');
        $('.checkout__shipping-accordion-wrapper-toggle').show();
        $('#collapseShipping').addClass('show');
      } else {
        $(this).val('');
        $('.checkout__shipping-accordion-wrapper-toggle').hide();
        $('#collapseShipping').removeClass('show');
      }
    });
    
   

  },
  updateCountryDropdown(countryCode) {
    // Update select dropdown with ID of billing_country and shipping_country to match the country code of the selected parcelshop.
    $('#shipping_country').val(countryCode);
  }
};

